/** What the user has approved the cogent keeping, and the way to take it back. */
export function CogentLessons({
  className,
  lessons,
  forget,
}: {
  className?: string | undefined
  lessons: string[]
  forget: (lesson: string) => void
}) {
  if (!lessons.length) return null

  return (
    <details className={className}>
      <summary>What I remember ({lessons.length})</summary>
      <ul>
        {lessons.map((lesson) => (
          <li key={lesson}>
            <span>{lesson}</span>
            <button type="button" aria-label={`Forget: ${lesson}`} onClick={() => forget(lesson)}>
              Forget
            </button>
          </li>
        ))}
      </ul>
    </details>
  )
}
